import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import { getConfig } from './config';

let api: AxiosInstance;

const activeRequests: Map<string, AbortController> = new Map();

export const createRequestKey = (url: string, method: string, identifier?: string): string => {
  if (identifier) {
    return `${method}:${identifier}`;
  }
  return `${method}:${url}`;
};

export const cancelRequest = (key: string): void => {
  const controller = activeRequests.get(key);
  if (controller) {
    controller.abort();
    activeRequests.delete(key);
  }
};

export const cancelAllRequests = (): void => {
  activeRequests.forEach((controller) => {
    controller.abort();
  });
  activeRequests.clear();
};

export const makeRequestWithAbort = (
  url: string,
  method: string,
  config?: AxiosRequestConfig,
  identifier?: string
): { requestConfig: AxiosRequestConfig; requestKey: string } => {
  const requestKey = createRequestKey(url, method, identifier);
  cancelRequest(requestKey);

  const controller = new AbortController();
  activeRequests.set(requestKey, controller);

  return {
    requestConfig: {
      ...config,
      signal: controller.signal,
    },
    requestKey,
  };
};

export default function makeApi() {
  if (!api) {
    api = axios.create({
      baseURL: getConfig('API_URL'),
    });
  }

  return api;
}
